import { render } from "./Hero.vue?vue&type=template&id=380e771e"
const script = {}

import "./Hero.vue?vue&type=style&index=0&id=380e771e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__